import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
// Element
import ElementUI, { Table } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// flex 布局库
import "flex.css";
// 组件
import "@/components";
// svg 图标
import "@/assets/svg-icons";
// 国际化
import _i18n from "@/i18n.js";

// 功能插件
import pluginApi from "@/plugin/api";
import pluginError from "@/plugin/error";
import pluginLog from "@/plugin/log";
import pluginOpen from "@/plugin/open";

// 解决 ElTable 自动宽度高度导致的「ResizeObserver loop limit exceeded」问题
var fixElTableErr = function fixElTableErr(table) {
  var oldResizeListener = table.methods.resizeListener;
  table.methods.resizeListener = function () {
    window.requestAnimationFrame(oldResizeListener.bind(this));
  };
};
// 一定要在Vue.use之前执行此函数
fixElTableErr(Table);
export default {
  install: function install(Vue, options) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // 设置为 false 以阻止 vue 在启动时生成生产提示
            // https://cn.vuejs.org/v2/api/#productionTip
            Vue.config.productionTip = false;
            // 当前环境
            Vue.prototype.$env = process.env.NODE_ENV;
            // 当前的 baseUrl
            Vue.prototype.$baseUrl = process.env.BASE_URL;
            // 当前版本
            Vue.prototype.$version = process.env.VUE_APP_VERSION;
            // 构建时间
            Vue.prototype.$buildTime = process.env.VUE_APP_BUILD_TIME;
            // Element
            Vue.use(ElementUI, {
              i18n: function i18n(key, value) {
                return _i18n.t(key, value);
              }
            });
            // 插件
            Vue.use(pluginApi);
            Vue.use(pluginError);
            Vue.use(pluginLog);
            Vue.use(pluginOpen);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  }
};